import Advantages from "../component/advantages";
import Footer from "../component/footer";
import Header from "../component/header";
import Hello from "../component/hello";
import Kwiz from "../component/kwɪz";
import Plus from "../component/plus";
import Catalog from "../component/catalog";
import Profitably from "../component/profitably";
import Reviews from "../component/reviews";
import Services from "../component/services";
export default function Main(params) {
    return (
        <>
            <Header />
            <main className="main">
                <Hello />
                {/* <Profitably /> */}
                <Catalog />
                <Plus />
                <Advantages />
                {/* <Services /> */}
                <Kwiz />
                <Reviews />
                <Footer />
            </main>
        </>
    );
}
